// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecas9{--tag-neutral-bg-color: var(--wpp-dataviz-color-seq-brand-400)}`, "",{"version":3,"sources":["webpack://./src/components/StatusMessage/StatusMessage.module.scss"],"names":[],"mappings":"AACA,OACE,8DAAA","sourcesContent":["@import \"/home/runner/work/commerce-studio/commerce-studio/apps/commerce-studio/src/styles/shared/utils.scss\";\n.blue_tag {\n  --tag-neutral-bg-color: var(--wpp-dataviz-color-seq-brand-400);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue_tag": `ecas9`
};
export default ___CSS_LOADER_EXPORT___;
